import { cn } from "@reactive-resume/utils";
import type { ReactNode } from "react";

type DashboardContentProps = {
  children: ReactNode;
  className?: string;
};

export const DashboardContent = ({ children, className }: DashboardContentProps) => {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-[1440px]",
        "px-4 py-5 sm:px-5 sm:py-6",
        "lg:px-7 lg:py-6 xl:px-8",
        className,
      )}
    >
      {children}
    </div>
  );
};
